import { useEffect, useState } from "react";

/**
 * Custom React hook to determine if the viewport width is less than or equal to a given breakpoint.
 *
 * Useful for responsive UIs: typically used to check if the app should display a mobile/tablet overlay.
 *
 * @param {number} [breakpoint] - The maximum width (in pixels) at which overlay mode should be considered active.
 * @returns {boolean} True if the window width is less than or equal to the breakpoint; otherwise, false.
 *
 * @example
 * const isOverlay = useOverlayActive(); // uses default tablet breakpoint
 * const isMobile = useOverlayActive(480); // custom breakpoint for mobile
 */
export function useOverlayActive(breakpoint = 1024) {
  const check = () => window.innerWidth <= breakpoint;
  const [isOverlay, setIsOverlay] = useState(check());

  useEffect(() => {
    const handleChange = () => setIsOverlay(check());
    window.addEventListener("resize", handleChange);
    window.addEventListener("orientationchange", handleChange);
    return () => {
      window.removeEventListener("resize", handleChange);
      window.removeEventListener("orientationchange", handleChange);
    };
  }, []);

  return isOverlay;
}